<template>
  <div>
    <span class="label">
      {{ field.metadata.radio.label }}
    </span>
    <span class="required" v-if="field.metadata.radio.required">*</span>
    <div
      v-for="(option, index) in field.metadata.radio.options"
      :key="index" 
      class="label"
    >
      <input
        type="radio"
        :value="option.value"
        :name="getName()"
        @click="setOption($event)"
        :id="getID(index)"
        :data-nextPdicsID="(count+1+index)"
      />
      <label :for="getID(index)">{{ option.label }}</label>
    </div>
    <div class="input-box" v-if="(this.selectedOption == 'I')">
      <input
        :name="field.metadata.fieldName"
        :readonly="field.metadata.readOnlyIfHasValue"
        placeholder=" "
        :required="field.metadata.required"
      />
      <div class="input-label">
        {{ field.metadata.text.ind.label }}
        <span class="required" v-if="field.metadata.text.ind.required">*</span>
      </div>
    </div>
    <div v-else-if="this.selectedOption == 'C'">
      <div class="input-box">
        <input
          :name="field.metadata.text.corp.company.fieldName"
          value=""
          placeholder=" "
          :required="field.metadata.text.corp.company.required"
        />
        <div class="input-label">
          {{ field.metadata.text.corp.company.label }}
          <span class="required" v-if="field.metadata.text.corp.company.required">*</span>
        </div>
      </div>
      <div class="input-box">
        <input
          :name="field.metadata.text.corp.companyRep.fieldName"
          value=""
          placeholder=" "
          :required="field.metadata.text.corp.companyRep.required"
        />
        <div class="input-label">
          {{ field.metadata.text.corp.companyRep.label }}
          <span class="required" v-if="field.metadata.text.corp.companyRep.required">*</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormPDICS",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      selectedOption: "",
      count: 0,
    };
  },
  methods: {
    setOption: function (event) {
      this.selectedOption = event.target.value;
    },
    setRadioChecked: function (value) {
      return value === this.selectedOption;
    },
    getID: function(index) {
      const ID_PREFIX = "form-pdics";
      return `${ID_PREFIX}-${this.count+index}`
    },
    getName: function() {
      return this.field.metadata.radio.fieldName + this.count;
    },
  },
  beforeMount() {
    const checkboxes = document.querySelectorAll("input[data-nextPdicsID]");
    if (checkboxes.length <= 0) {
      this.count = 1;
    } else {
      this.count = parseInt(checkboxes[checkboxes.length-1].dataset.nextpdicsid);
    }
  },
};
</script>

<style scoped>
.label {
  margin: 0.2rem 0;
}

.input-box {
  border: 1px solid #767676;
  border-radius: 4px;
  width: 100%;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  margin-top: 1rem;
  background: #fff;
  padding-left: 0.3rem;
  position: relative;
  overflow: visible;
}

.input-box > input {
  flex-grow: 1;
  font-size: 14px;
  background: #fff;
  border: none;
  outline: none;
  padding: 0.5rem;
  padding-left: 0;
  margin-top: 0.2rem;
  height: 1.5rem;
}

.input-label {
  position: absolute;
  transition: 0.2s;
  pointer-events: none;
  top: 0.65rem;
  font-size: 16px;
  white-space: nowrap;
  background: #fff;
}

.input-box > input:focus ~ .input-label,
.input-box > input:not(:placeholder-shown) ~ .input-label {
  top: -0.5rem;
  color: #0073c3;
  font-size: 13px;
  padding: 0 2px;
}

.input-box:focus-within {
  border: 2px solid #0073c3;
}

.required {
  color: #f00;
}
</style>